import React, { useState } from "react";
import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import { BtnCancel } from "../../components/styles";

function ViewImages({ row, onClose }) {
  const [open, setOpen] = useState(false);
  const [selected, SetSelected] = useState(null);

  const toggle = (img = null) => {
    setOpen((prev) => !prev);
    SetSelected(img);
  };
  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <Typography sx={{ my: 1.6, textAlign: "center" }}>
        Uploaded Images
      </Typography>

      <DialogContent dividers>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          {row.pics.map((img, i) => {
            return (
              <img
                className="view-image"
                key={i}
                src={img}
                alt=""
                onMouseEnter={() => toggle(img)}
              />
            );
          })}
        </Box>
        <Box sx={{ my: 1.6, display: "flex", justifyContent: "center" }}>
          <Button
            size="small"
            variant="conatined"
            sx={{ background: "#999 !important", color: "#fff" }}
            onClick={onClose}
          >
            Close
          </Button>
        </Box>
      </DialogContent>
      <Dialog open={open} onClose={toggle} fullWidth maxWidth="lg">
        <Box className="uploaded-pic">
          <img
            height="100%"
            width="100%"
            src={selected}
            alt=""
            onMouseLeave={toggle}
          />
          <Box className="uploaded-pic-delete">
            <BtnCancel variant="contained" onClick={toggle}>
              Close
            </BtnCancel>
          </Box>
        </Box>
      </Dialog>
    </Dialog>
  );
}

export default ViewImages;
